export const PORTLET_LAYOUT = "PORTLET_LAYOUT";
export const PORTLET_LAYOUT_ADD = PORTLET_LAYOUT + ".ADD";
export const PORTLET_LAYOUT_DELETE = PORTLET_LAYOUT + ".DELETE";
export const PORTLET_LAYOUT_UPDATE = PORTLET_LAYOUT + ".UPDATE";
export const LAYOUT = "LAYOUT";
export const LAYOUT_ADD = LAYOUT + ".ADD";
export const LAYOUT_DELETE = LAYOUT + ".DELETE";
export const LAYOUT_UPDATE = LAYOUT + ".UPDATE";
export const MENU_PORTLET = "MENU_PORTLET";
export const MENU_PORTLET_ADD = MENU_PORTLET + ".ADD";
export const MENU_PORTLET_DELETE = MENU_PORTLET + ".DELETE";
export const MENU_PORTLET_UPDATE = MENU_PORTLET + ".UPDATE";
export const HOT_TOPIC = "HOT_TOPIC";
export const HOT_TOPIC_ADD = HOT_TOPIC + ".ADD";
export const HOT_TOPIC_UPDATE = HOT_TOPIC + ".UPDATE";
export const KNOWLEDGE_ITEM = "KNOWLEDGE_ITEM";
export const KNOWLEDGE_ITEM_ADD = KNOWLEDGE_ITEM + ".ADD";
export const TEMPLATE = "TEMPLATE";
export const TEMPLATE_UPDATE = TEMPLATE + ".UPDATE";
export const TEMPLATE_ADD = TEMPLATE + ".ADD";
export const PORTLET_ATTACHMENT = "PORTLET_ATTACHMENT";
export const PORTLET_ATTACHMENT_ADD = PORTLET_ATTACHMENT + ".ADD";
export const REWORK = "REWORK";
export const REWORK_ADD = REWORK + ".ADD";
export const REWORK_UPDATE = REWORK + ".UPDATE";
export const EDIT_SELECTED = "EDIT_SELECTED";
export const USER_LIST = "USER_LIST";
export const USER_LIST_ADD = USER_LIST + ".ADD";
export const USER_LIST_DELETE = USER_LIST + ".DELETE";
export const LOGOUT = "LOGOUT";
